// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Blog.css */
:root {
  --blog-primary: #2d3277;
  --blog-accent: #3483fa;
  --blog-text: #333333;
  --blog-bg: #f5f7fa;
}

.blog-home-container {
  padding-bottom: 60px;
  background-color: var(--blog-bg);
  min-height: 100vh;
}

.blog-header {
  background-color: var(--blog-primary);
  color: white;
  padding: 60px 0;
  text-align: center;
  margin-bottom: 40px;
}

.blog-header h1 {
  font-size: 3rem;
  margin-bottom: 15px;
  font-weight: 800;
}

.blog-header p {
  font-size: 1.2rem;
  opacity: 0.9;
}

/* Breadcrumbs */
.breadcrumbs {
  margin-bottom: 20px;
  font-size: 14px;
}

.breadcrumbs a {
  text-decoration: none;
  color: var(--blog-accent);
}

.breadcrumbs.light {
  color: rgba(255, 255, 255, 0.8);
}

.breadcrumbs.light a {
  color: white;
}

.blog-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
  margin-top: -20px;
}

.blog-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
}

.blog-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
}

.blog-card-image {
  height: 200px;
  overflow: hidden;
}

.blog-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.blog-card:hover .blog-card-image img {
  transform: scale(1.05);
}

.blog-card-content {
  padding: 20px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.blog-category {
  font-size: 0.8rem;
  text-transform: uppercase;
  color: var(--blog-accent);
  font-weight: 700;
  margin-bottom: 10px;
  display: inline-block;
}

.blog-card h2 {
  font-size: 1.4rem;
  margin-bottom: 12px;
  line-height: 1.3;
}

.blog-card h2 a {
  text-decoration: none;
  color: var(--blog-text);
  transition: color 0.2s;
}

.blog-card h2 a:hover {
  color: var(--blog-accent);
}

.blog-excerpt {
  color: #666;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 20px;
}

.blog-card-footer {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #eee;
  padding-top: 15px;
}

.blog-date {
  font-size: 0.85rem;
  color: #999;
}

.read-more {
  font-weight: 700;
  color: var(--blog-accent);
  text-decoration: none;
  font-size: 0.9rem;
}

/* Post Detail Styles */
.post-detail-container {
  background-color: white;
  min-height: 100vh;
  padding-bottom: 80px;
}

.blog-content-layout {
  display: grid;
  grid-template-columns: 1fr 350px;
  gap: 40px;
}

.post-content-wrapper {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.03);
  line-height: 1.8;
  font-size: 1.15rem;
  color: #333;
}

.post-body h1, .post-body h2, .post-body h3 {
  margin-top: 30px;
  margin-bottom: 20px;
  color: #111;
}

.post-body p {
  margin-bottom: 1.5rem;
}

.post-body img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 30px 0;
}

/* Sidebar Widgets */
.post-sidebar {
  position: sticky;
  top: 100px;
  align-self: start;
}

/* Quill / Rich Text Styles */
.post-body .ql-align-center { text-align: center; }
.post-body .ql-align-right { text-align: right; }
.post-body .ql-align-justify { text-align: justify; }
.post-body .ql-size-small { font-size: 0.75em; }
.post-body .ql-size-large { font-size: 1.5em; }
.post-body .ql-size-huge { font-size: 2.5em; }
.post-body blockquote {
  border-left: 4px solid var(--blog-accent);
  padding-left: 20px;
  margin-left: 0;
  font-style: italic;
  color: #555;
}
.post-body .ql-video {
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: 8px;
  margin: 20px 0;
}

.related-offer-widget h3, .newsletter-widget h3 {
  margin-top: 0;
  color: var(--blog-primary);
}

.btn-whatsapp-join:hover {
  opacity: 0.9;
  transform: scale(1.02);
}

@media (max-width: 992px) {
  .blog-content-layout {
    grid-template-columns: 1fr;
  }
  .post-sidebar {
    position: static;
  }
  .post-content-wrapper {
    padding: 20px;
  }
  .blog-header h1 {
    font-size: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Blog.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,qDAAqD;EACrD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B,8BAA8B,kBAAkB,EAAE;AAClD,6BAA6B,iBAAiB,EAAE;AAChD,+BAA+B,mBAAmB,EAAE;AACpD,4BAA4B,iBAAiB,EAAE;AAC/C,4BAA4B,gBAAgB,EAAE;AAC9C,2BAA2B,gBAAgB,EAAE;AAC7C;EACE,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Blog.css */\r\n:root {\r\n  --blog-primary: #2d3277;\r\n  --blog-accent: #3483fa;\r\n  --blog-text: #333333;\r\n  --blog-bg: #f5f7fa;\r\n}\r\n\r\n.blog-home-container {\r\n  padding-bottom: 60px;\r\n  background-color: var(--blog-bg);\r\n  min-height: 100vh;\r\n}\r\n\r\n.blog-header {\r\n  background-color: var(--blog-primary);\r\n  color: white;\r\n  padding: 60px 0;\r\n  text-align: center;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.blog-header h1 {\r\n  font-size: 3rem;\r\n  margin-bottom: 15px;\r\n  font-weight: 800;\r\n}\r\n\r\n.blog-header p {\r\n  font-size: 1.2rem;\r\n  opacity: 0.9;\r\n}\r\n\r\n/* Breadcrumbs */\r\n.breadcrumbs {\r\n  margin-bottom: 20px;\r\n  font-size: 14px;\r\n}\r\n\r\n.breadcrumbs a {\r\n  text-decoration: none;\r\n  color: var(--blog-accent);\r\n}\r\n\r\n.breadcrumbs.light {\r\n  color: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n.breadcrumbs.light a {\r\n  color: white;\r\n}\r\n\r\n.blog-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 30px;\r\n  margin-top: -20px;\r\n}\r\n\r\n.blog-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 15px rgba(0,0,0,0.05);\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.blog-card:hover {\r\n  transform: translateY(-8px);\r\n  box-shadow: 0 10px 25px rgba(0,0,0,0.1);\r\n}\r\n\r\n.blog-card-image {\r\n  height: 200px;\r\n  overflow: hidden;\r\n}\r\n\r\n.blog-card-image img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  transition: transform 0.5s ease;\r\n}\r\n\r\n.blog-card:hover .blog-card-image img {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.blog-card-content {\r\n  padding: 20px;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.blog-category {\r\n  font-size: 0.8rem;\r\n  text-transform: uppercase;\r\n  color: var(--blog-accent);\r\n  font-weight: 700;\r\n  margin-bottom: 10px;\r\n  display: inline-block;\r\n}\r\n\r\n.blog-card h2 {\r\n  font-size: 1.4rem;\r\n  margin-bottom: 12px;\r\n  line-height: 1.3;\r\n}\r\n\r\n.blog-card h2 a {\r\n  text-decoration: none;\r\n  color: var(--blog-text);\r\n  transition: color 0.2s;\r\n}\r\n\r\n.blog-card h2 a:hover {\r\n  color: var(--blog-accent);\r\n}\r\n\r\n.blog-excerpt {\r\n  color: #666;\r\n  font-size: 0.95rem;\r\n  line-height: 1.6;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.blog-card-footer {\r\n  margin-top: auto;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  border-top: 1px solid #eee;\r\n  padding-top: 15px;\r\n}\r\n\r\n.blog-date {\r\n  font-size: 0.85rem;\r\n  color: #999;\r\n}\r\n\r\n.read-more {\r\n  font-weight: 700;\r\n  color: var(--blog-accent);\r\n  text-decoration: none;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Post Detail Styles */\r\n.post-detail-container {\r\n  background-color: white;\r\n  min-height: 100vh;\r\n  padding-bottom: 80px;\r\n}\r\n\r\n.blog-content-layout {\r\n  display: grid;\r\n  grid-template-columns: 1fr 350px;\r\n  gap: 40px;\r\n}\r\n\r\n.post-content-wrapper {\r\n  background: white;\r\n  padding: 40px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 20px rgba(0,0,0,0.03);\r\n  line-height: 1.8;\r\n  font-size: 1.15rem;\r\n  color: #333;\r\n}\r\n\r\n.post-body h1, .post-body h2, .post-body h3 {\r\n  margin-top: 30px;\r\n  margin-bottom: 20px;\r\n  color: #111;\r\n}\r\n\r\n.post-body p {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.post-body img {\r\n  max-width: 100%;\r\n  height: auto;\r\n  border-radius: 8px;\r\n  margin: 30px 0;\r\n}\r\n\r\n/* Sidebar Widgets */\r\n.post-sidebar {\r\n  position: sticky;\r\n  top: 100px;\r\n  align-self: start;\r\n}\r\n\r\n/* Quill / Rich Text Styles */\r\n.post-body .ql-align-center { text-align: center; }\r\n.post-body .ql-align-right { text-align: right; }\r\n.post-body .ql-align-justify { text-align: justify; }\r\n.post-body .ql-size-small { font-size: 0.75em; }\r\n.post-body .ql-size-large { font-size: 1.5em; }\r\n.post-body .ql-size-huge { font-size: 2.5em; }\r\n.post-body blockquote {\r\n  border-left: 4px solid var(--blog-accent);\r\n  padding-left: 20px;\r\n  margin-left: 0;\r\n  font-style: italic;\r\n  color: #555;\r\n}\r\n.post-body .ql-video {\r\n  width: 100%;\r\n  aspect-ratio: 16/9;\r\n  border-radius: 8px;\r\n  margin: 20px 0;\r\n}\r\n\r\n.related-offer-widget h3, .newsletter-widget h3 {\r\n  margin-top: 0;\r\n  color: var(--blog-primary);\r\n}\r\n\r\n.btn-whatsapp-join:hover {\r\n  opacity: 0.9;\r\n  transform: scale(1.02);\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .blog-content-layout {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .post-sidebar {\r\n    position: static;\r\n  }\r\n  .post-content-wrapper {\r\n    padding: 20px;\r\n  }\r\n  .blog-header h1 {\r\n    font-size: 2rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
